import React from "react";
import { ActionButton, useStyles } from "./styles";
import { ExpandMore } from "@material-ui/icons";
import { Menu } from "@material-ui/core";

export interface IListGridFilterMenu {
    label: string;
    children: React.ReactNode;
    testLabel: string;
    isSelected: boolean;
    onCloseMenu?: () => void;
    buttonStyle?: any;
}

export const ListGridFilterMenu: React.FC<IListGridFilterMenu> = ({
    label,
    children = {},
    onCloseMenu = () => {},
    testLabel,
    isSelected = false,
    buttonStyle = {},
}) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        onCloseMenu();
    };

    const classes = useStyles();

    return (
        <div>
            <ActionButton
                aria-controls={open ? "demo-customized-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="contained"
                disableElevation
                endIcon={<ExpandMore />}
                onClick={handleClick}
                data-test={testLabel}
                style={isSelected ? { ...buttonStyle, backgroundColor: "#f1f5fa" } : { ...buttonStyle }}
            >
                {label}
            </ActionButton>
            <Menu
                id="demo-customized-menu"
                MenuListProps={{
                    "aria-labelledby": "demo-customized-button",
                    className: classes.filterMenu,
                }}
                elevation={0}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                open={open}
                onClose={handleClose}
                onSubmit={handleClose}
            >
                {children}
            </Menu>
        </div>
    );
};
